import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { categorySchema } from "./schema";
import { fetchCategoryData } from "./read";
import { useUpdateCategory } from "../update/mutation";
import { useCreateCategory } from "../create/mutation";

export const useCategoryForm = ({ categoryId }) => {
  const form = useForm({
    resolver: zodResolver(categorySchema),
    defaultValues: {
      name: "",
    },
  });

  const updateCategory = useUpdateCategory();
  const createCategory = useCreateCategory();

  const handleCreate = async (context) => {
    const item = context.values;
    await createCategory.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateCategory.mutateAsync({ categoryId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchCategoryData({ categoryId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
